<div
  class="error animated shake p-l-16"
  [ngClass]="{'validation': isValidation}"
  *ngIf="isInvalid || errorMessage">
  <span *ngIf="!errorMessage && !isPattern && !isMinLength">{{ labelName }} is required</span>
  <span *ngIf="!errorMessage && (isPattern || isMinLength)">{{ message }}</span>
  <span *ngIf="errorMessage">{{ errorMessage }}</span>
</div>